import { FormCard, FormItem, TextArea } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import LastUpdateBox from 'components/carePlans/LastUpdateBox'
import { lastUpdateCarerFromUpdatedByData } from 'components/carePlans/lastUpdateCarerFromUpdatedByData'
import type { ResidentItemExtended } from 'hooks/useResident'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'
import { SupDatePicker } from '../../../styledComponents'
import { dateFormat } from '../../../utils/utils'

export const EnvironmentFormCard = ({
  resident,
  testId
}: {
  resident?: ResidentItemExtended
  testId?: string
} = {}) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)
  const updatedAt = resident?.environment?.updatedAt
  const updatedByCarer = lastUpdateCarerFromUpdatedByData(
    resident?.environment?.updatedByData
  )

  return (
    <FormCard
      title={t(supConstants.ENVIRONMENT)}
      testId={testId ? `${testId}-environment-card` : 'environment-card'}
    >
      <FormItem
        label={<Text>{t(supConstants.HOUSEHOLD_COMPOSITION)}</Text>}
        name={['environment', 'householdComposition']}
      >
        <TextArea
          autoSize={{ minRows: 3 }}
          placeholder={t(supConstants.HOUSEHOLD_COMPOSITION_PLACEHOLDER)}
        />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.HOUSEHOLD_ENVIRONMENT)}</Text>}
        name={['environment', 'householdEnvironment']}
      >
        <TextArea
          autoSize={{ minRows: 5 }}
          placeholder={t(supConstants.HOUSEHOLD_ENVIRONMENT_PLACEHOLDER)}
        />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.ENVIRONMENT_DESCRIPTION)}</Text>}
        name={['environment', 'environmentDescription']}
      >
        <TextArea
          autoSize={{ minRows: 5 }}
          placeholder={t(supConstants.ENVIRONMENT_DESCRIPTION_PLACEHOLDER)}
        />
      </FormItem>
      <FormItem
        label={<Text>{t(supConstants.DATE_OF_OBSERVATION)}</Text>}
        name={['environment', 'dateOfObservation']}
      >
        <SupDatePicker placeholder="" format={dateFormat} />
      </FormItem>
      {updatedAt && (
        <LastUpdateBox
          date={updatedAt}
          carer={updatedByCarer}
          noDateText=""
          style={{ paddingInline: 0 }}
        />
      )}
    </FormCard>
  )
}
